import './style.css'

export const Name = ({ children }) => {
  return (
    <span className='name__content'>{children}</span>
  )
}
